import SuggestionList from './SuggestionList';

export default SuggestionList;
